export interface AuthHeaders {
  wlClient: string;
  requestSource: string;
  requestAction: string;
}
